import React from "react";
import Product from "../product/Product";
import "./productList.css";
import { products } from "../../data";

const ProductList = () => {
  return (
    <div className="pl">
      <div className="pl-texts">
        <div className="pl-title">MY PROJECTS</div>
        <div className="pl-desc">
          Here are the main projects (Both Personal and Team) that I have worked
          on in the past.
        </div>
      </div>
      <div className="pl-list">
        {products.map((item) => (
          <Product
            key={item.id}
            img={item.img}
            link={item.link}
            title={item.title}
          />
        ))}
      </div>
    </div>
  );
};

export default ProductList;
